import type { CrmMessages } from "./englishCrmMessages";
import { portugueseFinanceMessages } from "./portugueseFinanceMessages";
import { portuguesePwaMessages } from "./portuguesePwaMessages";

export const portugueseCrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nome da empresa",
        website: "Site",
        linkedin_url: "URL do LinkedIn",
        phone_number: "Telefone",
        created_at: "Criada em",
        nb_contacts: "Número de contatos",
        revenue: "Faturamento",
        sector: "Setor",
        size: "Porte",
        tax_identifier: "CNPJ / identificação fiscal",
        address: "Endereço",
        city: "Cidade",
        zipcode: "CEP",
        state_abbr: "Estado",
        country: "País",
        description: "Descrição",
        context_links: "Links de contexto",
        sales_id: "Responsável pela conta",
      },
      empty: {
        description: "Parece que sua lista de empresas está vazia.",
        title: "Nenhuma empresa encontrada",
      },
      import: {
        title: "Importar empresas",
      },
      field_categories: {
        contact: "Contato",
        additional_info: "Informações adicionais",
        address: "Endereço",
        context: "Contexto",
      },
      action: {
        create: "Criar empresa",
        edit: "Editar empresa",
        new: "Nova empresa",
        show: "Ver empresa",
      },
      added_on: "Adicionada em %{date}",
      followed_by: "Acompanhada por %{name}",
      followed_by_you: "Acompanhada por você",
      no_contacts: "Nenhum contato",
      nb_contacts: "%{smart_count} contato |||| %{smart_count} contatos",
      nb_deals: "%{smart_count} negócio |||| %{smart_count} negócios",
      sizes: {
        one_employee: "1 funcionário",
        two_to_nine_employees: "2-9 funcionários",
        ten_to_forty_nine_employees: "10-49 funcionários",
        fifty_to_two_hundred_forty_nine_employees: "50-249 funcionários",
        two_hundred_fifty_or_more_employees: "250 funcionários ou mais",
      },
      autocomplete: {
        create_error: "Ocorreu um erro ao criar a empresa",
        create_item: "Criar %{item}",
        create_label: "Comece a digitar para criar uma nova empresa",
      },
    },
    contacts: {
      name: "Contato |||| Contatos",
      forcedCaseName: "Contato",
      field_categories: {
        background_info: "Histórico",
        identity: "Identidade",
        misc: "Outros",
        personal_info: "Informações pessoais",
        position: "Cargo",
      },
      fields: {
        first_name: "Nome",
        last_name: "Sobrenome",
        last_seen: "Último contato",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Endereços de e-mail",
        email: "E-mail",
        phone_jsonb: "Telefones",
        phone_number: "Telefone",
        linkedin_url: "URL do LinkedIn",
        background: "Histórico (bio, como se conheceram etc.)",
        has_newsletter: "Recebe newsletter",
        sales_id: "Responsável pela conta",
      },
      action: {
        add: "Adicionar contato",
        add_first: "Adicione seu primeiro contato",
        create: "Criar contato",
        edit: "Editar contato",
        export_vcard: "Exportar para vCard",
        new: "Novo contato",
        show: "Ver contato",
      },
      background: {
        last_activity_on: "Última atividade em %{date}",
        added_on: "Adicionado em %{date}",
        followed_by: "Acompanhado por %{name}",
        followed_by_you: "Acompanhado por você",
        status_none: "Nenhum",
      },
      position_at: "%{title} na",
      position_at_company: "%{title} na %{company}",
      empty: {
        description: "Parece que sua lista de contatos está vazia.",
        title: "Nenhum contato encontrado",
      },
      import: {
        title: "Importar contatos",
      },
      inputs: {
        genders: {
          male: "Ele/Dele",
          female: "Ela/Dela",
          nonbinary: "Elu/Delu",
        },
        personal_info_types: {
          work: "Trabalho",
          home: "Casa",
          other: "Outro",
        },
      },
      list: {
        error_loading: "Erro ao carregar os contatos",
      },
      bulk_tag: {
        action: "Etiquetar",
        back: "Voltar às etiquetas",
        create_description:
          "Crie uma nova etiqueta e aplique-a aos contatos selecionados.",
        description:
          "Escolha uma etiqueta existente ou crie uma nova para os contatos selecionados.",
        empty:
          "Nenhuma etiqueta ainda. Crie uma para etiquetar os contatos selecionados.",
        error: "Falha ao adicionar a etiqueta aos contatos",
        noop: "Os contatos selecionados já têm esta etiqueta",
        success:
          "Etiqueta adicionada a %{smart_count} contato |||| Etiqueta adicionada a %{smart_count} contatos",
        title: "Adicionar etiqueta aos contatos",
      },
      merge: {
        action: "Mesclar com outro contato",
        confirm: "Mesclar contatos",
        current_contact: "Contato atual (será excluído)",
        description: "Mescle este contato com outro.",
        error: "Falha ao mesclar os contatos",
        merging: "Mesclando...",
        no_additional_data: "Nenhum dado adicional para mesclar",
        select_target: "Selecione um contato para mesclar",
        success: "Contatos mesclados com sucesso",
        target_contact: "Contato de destino (será mantido)",
        title: "Mesclar contato",
        warning_description:
          "Todos os dados serão transferidos para o segundo contato. Esta ação não pode ser desfeita.",
        warning_title: "Atenção: operação destrutiva",
        what_will_be_merged: "O que será mesclado:",
      },
      filters: {
        before_last_month: "Antes do mês passado",
        before_this_month: "Antes deste mês",
        before_this_week: "Antes desta semana",
        managed_by_me: "Sob minha responsabilidade",
        search: "Buscar nome, empresa...",
        this_week: "Esta semana",
        today: "Hoje",
        tags: "Etiquetas",
        tasks: "Tarefas",
      },
      hot: {
        empty_change_status:
          'Mude o status de um contato adicionando uma nota a ele e clicando em "mostrar opções".',
        empty_hint: 'Contatos com status "quente" aparecerão aqui.',
        title: "Contatos quentes",
      },
    },
    deals: {
      name: "Negócio |||| Negócios",
      fields: {
        name: "Nome",
        description: "Descrição",
        company_id: "Empresa",
        contact_ids: "Contatos",
        category: "Categoria",
        amount: "Orçamento",
        expected_closing_date: "Previsão de fechamento",
        stage: "Etapa",
      },
      action: {
        back_to_deal: "Voltar ao negócio",
        create: "Criar negócio",
        new: "Novo negócio",
      },
      field_categories: {
        misc: "Outros",
      },
      filters: {
        only_mine: "Só os negócios que eu gerencio",
      },
      archived: {
        action: "Arquivar",
        error: "Erro: negócio não arquivado",
        list_title: "Negócios arquivados",
        success: "Negócio arquivado",
        title: "Negócio arquivado",
        view: "Ver negócios arquivados",
      },
      inputs: {
        linked_to: "Vinculado a",
      },
      unarchived: {
        action: "Devolver ao quadro",
        error: "Erro: negócio não desarquivado",
        success: "Negócio desarquivado",
      },
      updated: "Negócio atualizado",
      empty: {
        before_create: "antes de criar um negócio.",
        description: "Parece que sua lista de negócios está vazia.",
        title: "Nenhum negócio encontrado",
      },
      import: {
        title: "Importar negócios",
      },
      invalid_date: "Data inválida",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Status",
        date: "Data",
        attachments: "Anexos",
        contact_id: "Contato",
        deal_id: "Negócio",
      },
      action: {
        add: "Adicionar nota",
        add_first: "Adicione sua primeira nota",
        delete: "Excluir nota",
        edit: "Editar nota",
        update: "Atualizar nota",
        add_this: "Adicionar esta nota",
      },
      sheet: {
        create: "Criar nota",
        create_for: "Criar nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota de %{name}",
      },
      deleted: "Nota excluída",
      empty: "Nenhuma nota ainda",
      author_added: "%{name} adicionou uma nota",
      you_added: "Você adicionou uma nota",
      me: "Eu",
      list: {
        error_loading: "Erro ao carregar as notas",
      },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Vá até a página de um contato e adicione uma nota",
      },
      added: "Nota adicionada",
      inputs: {
        add_note: "Adicionar uma nota",
        options_hint: "(anexar arquivos ou alterar detalhes)",
        show_options: "Mostrar opções",
      },
      actions: {
        attach_document: "Anexar documento",
      },
      validation: {
        note_or_attachment_required: "É preciso uma nota ou um anexo",
      },
    },
    sales: {
      name: "Usuário |||| Usuários",
      fields: {
        first_name: "Nome",
        last_name: "Sobrenome",
        email: "E-mail",
        secondary_email: "E-mail secundário",
        secondary_emails: "E-mails secundários",
        administrator: "Administrador",
        disabled: "Desativado",
      },
      create: {
        error: "Ocorreu um erro ao criar o usuário.",
        success:
          "Usuário criado. Em breve ele receberá um e-mail para definir a senha.",
        title: "Criar um novo usuário",
      },
      edit: {
        error: "Ocorreu um erro. Tente novamente.",
        record_not_found: "Registro não encontrado",
        success: "Usuário atualizado com sucesso",
        title: "Editar %{name}",
      },
      action: {
        new: "Novo usuário",
      },
    },
    tasks: {
      name: "Tarefa |||| Tarefas",
      forcedCaseName: "Tarefa",
      fields: {
        text: "Descrição",
        due_date: "Prazo",
        type: "Tipo",
        contact_id: "Contato",
        due_short: "prazo",
      },
      action: {
        add: "Adicionar tarefa",
        create: "Criar tarefa",
        edit: "Editar tarefa",
      },
      actions: {
        postpone_next_week: "Adiar para a próxima semana",
        postpone_tomorrow: "Adiar para amanhã",
        title: "ações da tarefa",
      },
      added: "Tarefa adicionada",
      deleted: "Tarefa excluída com sucesso",
      dialog: {
        create: "Criar tarefa",
        create_for: "Criar tarefa para %{name}",
      },
      sheet: {
        edit: "Editar tarefa",
        edit_for: "Editar tarefa de %{name}",
      },
      empty: "Nenhuma tarefa ainda",
      empty_list_hint:
        "As tarefas adicionadas aos seus contatos aparecerão aqui.",
      filters: {
        later: "Depois",
        overdue: "Atrasadas",
        this_week: "Esta semana",
        today: "Hoje",
        tomorrow: "Amanhã",
        with_pending: "Com tarefas pendentes",
      },
      regarding_contact: "(Ref.: %{name})",
      updated: "Tarefa atualizada",
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: {
        add: "Adicionar etiqueta",
        create: "Criar nova etiqueta",
      },
      dialog: {
        color: "Cor",
        create_title: "Criar uma nova etiqueta",
        edit_title: "Editar etiqueta",
        name_label: "Nome da etiqueta",
        name_placeholder: "Digite o nome da etiqueta",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Redefinir senha",
    },
    auth: {
      team_name: "Nome da empresa / equipe",
      first_name: "Nome",
      last_name: "Sobrenome",
      confirm_password: "Confirmar senha",
      confirmation_required:
        "Clique no link que acabamos de enviar por e-mail para confirmar sua conta.",
      recovery_email_sent:
        "Se você for um usuário cadastrado, receberá em breve um e-mail para recuperar a senha.",
      sign_in_failed: "Falha ao entrar.",
      sign_in_google_workspace: "Entrar com o Google Workspace",
      signup: {
        create_team:
          "Crie sua conta e sua equipe. Depois você pode convidar seus colegas.",
        team_created: "Sua conta e sua equipe estão prontas",
        have_account: "Já tem conta? Entrar",
        no_account: "Ainda não tem conta? Crie sua equipe",
        create_account: "Criar conta",
        create_first_user:
          "Crie a primeira conta de usuário para concluir a configuração.",
        creating: "Criando...",
        initial_user_created: "Usuário inicial criado com sucesso",
      },
      welcome_title: "Bem-vindo ao Atomic CRM",
    },
    common: {
      account_manager: "Responsável pela conta",
      activity: "Atividade",
      added: "adicionou",
      details: "Detalhes",
      last_activity_with_date: "última atividade %{date}",
      load_more: "Carregar mais",
      misc: "Outros",
      past: "Passadas",
      read_more: "Ler mais",
      retry: "Tentar novamente",
      show_less: "Mostrar menos",
      copied: "Copiado!",
      copy: "Copiar",
      no_matching_item: "Nenhum item encontrado.",
      no_results_found: "Nenhum resultado encontrado.",
      loading: "Carregando...",
      me: "Eu",
      task_count: "%{smart_count} tarefa |||| %{smart_count} tarefas",
    },
    changelog: {
      title: "Novidades",
    },
    activity: {
      added_company: "%{name} adicionou a empresa",
      you_added_company: "Você adicionou a empresa",
      added_contact: "%{name} adicionou",
      you_added_contact: "Você adicionou",
      added_note: "%{name} adicionou uma nota sobre",
      you_added_note: "Você adicionou uma nota sobre",
      added_note_about_deal: "%{name} adicionou uma nota sobre o negócio",
      you_added_note_about_deal: "Você adicionou uma nota sobre o negócio",
      added_deal: "%{name} adicionou o negócio",
      you_added_deal: "Você adicionou o negócio",
      at_company: "na",
      to: "para",
      load_more: "Carregar mais atividades",
    },
    dashboard: {
      deals_chart: "Receita prevista dos negócios",
      deals_pipeline: "Funil de negócios",
      welcome: {
        title: "Seu kit inicial de CRM",
        template:
          "é um modelo criado para ajudar você a construir rapidamente seu próprio CRM.",
        demo: "Esta demonstração usa uma API simulada, então você pode explorar e modificar os dados. Eles são redefinidos ao recarregar. A versão completa usa o Supabase como backend.",
        powered_by: "Desenvolvido com",
        open_source:
          ", o Atomic CRM é totalmente open source. O código está em",
      },
      latest_activity: "Atividade recente",
      latest_activity_error: "Erro ao carregar a atividade recente",
      latest_notes: "Minhas notas recentes",
      latest_notes_added_ago: "adicionada %{timeAgo}",
      stepper: {
        install: "Instalar o Atomic CRM",
        progress: "%{step}/3 concluídos",
        whats_next: "Próximos passos",
      },
      upcoming_tasks: "Próximas tarefas",
    },
    data_import: {
      button: "Importar CSV",
      complete:
        "Importação concluída. %{importCount} registros importados, com %{errorCount} erros",
      csv_file: "Arquivo CSV",
      error:
        "Falha ao importar este arquivo. Verifique se é um arquivo CSV válido.",
      in_progress: "Importação em andamento…",
      progress:
        "%{importCount} / %{rowCount} registros importados, com %{errorCount} erros.",
      remaining_time: "Tempo restante estimado:",
      resource: "Recurso",
      sample_download: "Baixar modelo CSV",
      sample_hint:
        "Aqui está um arquivo CSV de exemplo que você pode usar como modelo",
      start: "Iniciar importação",
      stop: "Parar importação",
      stopped:
        "Importação interrompida. %{importCount} registros importados, com %{errorCount} erros",
      title: "Importar dados",
    },
    header: {
      import_data: "Importar de JSON",
    },
    image_editor: {
      change: "Alterar",
      drop_hint: "Arraste um arquivo para enviar ou clique para selecioná-lo.",
      editable_content: "Conteúdo editável",
      title: "Enviar e redimensionar imagem",
      update_image: "Atualizar imagem",
    },
    import: {
      action: {
        download_error_report: "Baixar o relatório de erros",
        import: "Importar",
        import_another: "Importar outro arquivo",
      },
      error: {
        unable: "Não foi possível importar este arquivo.",
      },
      idle: {
        description_1:
          "Você pode importar usuários, empresas, contatos, notas e tarefas.",
        description_2:
          "Os dados devem estar em um arquivo JSON igual ao exemplo a seguir:",
      },
      status: {
        all_success: "Todos os registros foram importados com sucesso.",
        complete: "Importação concluída.",
        failed: "Falhou",
        imported: "Importado",
        in_progress: "Importação em andamento. Não saia desta página.",
        some_failed: "Alguns registros não foram importados.",
        table_caption: "Status da importação",
      },
      title: "Importar de JSON",
    },
    settings: {
      about: "Sobre",
      companies: {
        sectors: "Setores",
      },
      dark_mode_logo: "Logo do modo escuro",
      deals: {
        categories: "Categorias",
        currency: "Moeda",
        pipeline_help:
          "Selecione quais etapas de negócio devem contar como negócios no funil.",
        pipeline_statuses: "Status do funil",
        stages: "Etapas",
      },
      light_mode_logo: "Logo do modo claro",
      notes: {
        statuses: "Status",
      },
      reset_defaults: "Restaurar padrões",
      save_error: "Falha ao salvar a configuração",
      saved: "Configuração salva com sucesso",
      saving: "Salvando...",
      tasks: {
        types: "Tipos",
      },
      preferences: "Preferências",
      title: "Configurações",
      app_title: "Título do app",
      sections: {
        branding: "Marca",
      },
      validation: {
        duplicate: "%{display_name} duplicadas: %{items}",
        in_use:
          "Não é possível remover %{display_name} que ainda estão em uso por negócios: %{items}",
        validating: "Validando…",
        entities: {
          categories: "categorias",
          stages: "etapas",
        },
      },
    },
    theme: {
      dark: "Escuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    navigation: {
      label: "Navegação do CRM",
    },
    profile: {
      add_secondary_email: "Adicionar um e-mail",
      email_taken: "%{email} já está em uso por outro usuário",
      no_secondary_emails: "Nenhum",
      secondary_email_invalid: "%{email} não é um endereço de e-mail válido",
      secondary_email_is_primary: "%{email} já é o seu endereço principal",
      secondary_email_taken: "%{email} já está em uso por outro usuário",
      too_many_secondary_emails:
        "Você não pode adicionar mais de 10 e-mails secundários",
      secondary_emails_help:
        "Outros endereços dos quais você envia e-mails. Deixe um vazio para removê-lo.",
      inbound: {
        description:
          "Você pode começar a enviar e-mails para o endereço de entrada do seu servidor, por exemplo adicionando-o ao campo %{field}. O Atomic CRM vai processar os e-mails e adicionar notas aos contatos correspondentes.",
        title: "E-mail de entrada",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Use esta URL para conectar seu assistente de IA aos dados do CRM pelo Model Context Protocol (MCP).",
      },
      password: {
        change: "Alterar senha",
      },
      password_reset_sent:
        "Um e-mail para redefinir a senha foi enviado para o seu endereço",
      record_not_found: "Registro não encontrado",
      title: "Perfil",
      updated: "Seu perfil foi atualizado",
      update_error: "Ocorreu um erro. Tente novamente",
    },
    validation: {
      invalid_url: "Deve ser uma URL válida",
      invalid_linkedin_url: "A URL deve ser do linkedin.com",
    },
    team: {
      title: "Equipe",
      subtitle: "Nome, membros e convites",
      name: "Nome da equipe",
      members: "%{smart_count} membro |||| %{smart_count} membros",
      invite: "Convidar membro",
      invite_help:
        "O convidado recebe um e-mail para entrar na equipe e só vê os dados dela.",
      role_admin: "Gestor",
      role_member: "Membro",
      disabled: "Desativado",
      renamed: "Equipe renomeada",
    },
    finance: portugueseFinanceMessages,
    pwa: portuguesePwaMessages,
    operations: {
      title: "Operações",
      load_more: "Carregar mais",
      tabs: {
        crm: "CRM",
        tasks: "Tarefas",
      },
      priorities: {
        low: "Baixa",
        medium: "Média",
        high: "Alta",
        urgent: "Urgente",
      },
      pipelines: {
        label: "Funil",
        create: "Novo funil",
        rename: "Renomear funil",
        delete: "Excluir funil",
        delete_title: "Excluir o funil %{name}?",
        delete_description:
          "As etapas e os cards saem de Operações. Os contatos, negociações e tarefas são mantidos.",
        name: "Nome do funil",
        default_name: "Vendas",
        with_default_stages: "Começar com as etapas padrão",
        created: "Funil criado",
        updated: "Funil renomeado",
        deleted: "Funil excluído",
        empty_title: "Nenhum funil ainda",
        empty:
          "Crie seu primeiro funil para acompanhar seus contatos em um kanban.",
        default_stages: {
          new_lead: "Novo lead",
          contacted: "Em contato",
          proposal: "Proposta",
          negotiation: "Negociação",
          closed: "Fechado",
        },
      },
      stages: {
        add: "Adicionar etapa",
        name: "Nome da etapa",
        rename: "Renomear",
        move_left: "Mover para a esquerda",
        move_right: "Mover para a direita",
        add_after: "Adicionar etapa depois",
        delete: "Excluir etapa",
        delete_title: "Excluir a etapa %{name}?",
        delete_empty: "Esta etapa está vazia e será removida.",
        delete_with_cards:
          "Esta etapa tem %{smart_count} card. Escolha para onde movê-lo antes. |||| Esta etapa tem %{smart_count} cards. Escolha para onde movê-los antes.",
        move_cards_to: "Mover os cards para",
        created: "Etapa adicionada",
        updated: "Etapa atualizada",
        deleted: "Etapa excluída",
        last_stage: "Um funil precisa de pelo menos uma etapa",
        actions: "Ações da etapa",
        drop_here: "Solte os cards aqui",
      },
      cards: {
        add: "Novo card",
        add_to_stage: "Adicionar card em %{stage}",
        create_title: "Novo card",
        created: "Card criado",
        created_partially:
          "Card criado, mas %{smart_count} item não pôde ser salvo |||| Card criado, mas %{smart_count} itens não puderam ser salvos",
        updated: "Card atualizado",
        moved: "Card movido",
        remove: "Remover do funil",
        remove_title: "Remover %{name} do funil?",
        remove_description:
          "O card sai deste funil. O contato, as negociações, tarefas e observações são mantidos.",
        removed: "Card removido do funil",
        open_contact: "Abrir página do contato",
        in_stage_since: "Nesta etapa desde %{date}",
        open_tasks:
          "%{smart_count} tarefa aberta |||| %{smart_count} tarefas abertas",
        overdue_tasks: "Tem tarefas atrasadas",
        unnamed: "(sem nome)",
        create: "Criar card",
      },
      fields: {
        name: "Nome",
        tags: "Tags",
        email: "E-mail",
        phone: "Telefone",
        assignee: "Responsável",
        source: "Fonte",
        priority: "Prioridade",
        stage: "Etapa",
      },
      placeholders: {
        name: "Nome do contato ou empresa",
        email: "nome@empresa.com",
        phone: "+55 11 99999-9999",
        search_tags: "Buscar ou criar uma tag…",
        search_source: "Buscar ou criar uma fonte…",
        empty_value: "Clique para adicionar",
      },
      combobox: {
        create: 'Criar "%{name}"',
        no_results: "Nada encontrado",
        none: "Nenhuma",
        remove: "Remover %{name}",
        used: "%{smart_count} uso |||| %{smart_count} usos",
      },
      deals: {
        title: "Negociações",
        add: "Nova negociação",
        name: "Nome do negócio",
        amount: "Oferta",
        description: "Descrição",
        created: "Negociação adicionada",
        deleted: "Negociação excluída",
        delete: "Excluir negociação",
        empty: "Nenhuma negociação ainda",
        total: "Total",
      },
      documents: {
        title: "Documentos",
        attach: "Anexar documento",
        deleted: "Documento excluído",
        delete: "Excluir documento",
        added: "Documento anexado",
        empty: "Nenhum documento ainda",
      },
      notes: {
        title: "Observações",
        add: "Observação",
        placeholder: "Escreva uma observação…",
        created: "Observação adicionada",
        deleted: "Observação excluída",
        delete: "Excluir observação",
        empty: "Nenhuma observação ainda",
      },
      tasks: {
        title: "Tarefas",
        add: "Adicionar tarefa",
        create: "Nova tarefa",
        edit: "Editar tarefa",
        delete: "Excluir tarefa",
        created: "Tarefa criada",
        updated: "Tarefa atualizada",
        deleted: "Tarefa excluída",
        moved: "Tarefa movida",
        empty: "Nenhuma tarefa ainda",
        empty_filtered: "Nenhuma tarefa corresponde aos filtros",
        count: "%{smart_count} tarefa |||| %{smart_count} tarefas",
        free: "Sem card",
        no_due: "Sem prazo",
        overdue: "Atrasada",
        hours: "%{spent}h de %{estimated}h",
        view_board: "Quadro",
        view_list: "Lista",
        statuses: {
          todo: "A fazer",
          doing: "Fazendo",
          blocked: "Bloqueada",
          done: "Concluída",
        },
        fields: {
          title: "Título",
          description: "Descrição",
          status: "Status",
          priority: "Prioridade",
          assignee: "Responsável",
          card: "Card",
          due_date: "Prazo",
          estimated_hours: "Horas esperadas",
          spent_hours: "Horas gastas",
          attachments: "Documentos",
          created_at: "Criada em",
        },
      },
      filters: {
        search: "Buscar…",
        user: "Usuário",
        all_users: "Todos os usuários",
        mine: "Só os meus",
        tags: "Tags",
        source: "Fonte",
        priority: "Prioridade",
        status: "Status",
        card: "Card",
        due: "Prazo",
        any: "Todas",
        clear: "Limpar filtros",
        active: "%{smart_count} filtro |||| %{smart_count} filtros",
        dues: {
          overdue: "Atrasadas",
          today: "Vencem hoje",
          week: "Vencem esta semana",
          none: "Sem prazo",
        },
      },
    },
    personal: {
      title: "Pessoal",
      subtitle: "Seu espaço de crescimento pessoal",
      calendar: {
        today: "Hoje",
        previous_month: "Mês anterior",
        next_month: "Próximo mês",
      },
      timeline: {
        title: "Agenda",
        hint: "Clique em um horário para criar um compromisso",
      },
      events: {
        create: "Novo compromisso",
        edit: "Editar compromisso",
        delete: "Excluir compromisso",
        created: "Compromisso adicionado",
        updated: "Compromisso atualizado",
        deleted: "Compromisso excluído",
        invalid_range: "O fim deve ser depois do início",
        fields: {
          title: "Título",
          start_at: "Início",
          end_at: "Fim",
          description: "Descrição",
          color: "Cor",
        },
      },
      todos: {
        title: "A fazer",
        add: "Adicionar tarefa",
        create: "Nova tarefa",
        edit: "Editar tarefa",
        delete: "Excluir tarefa",
        mark_done: "Marcar como concluída",
        created: "Tarefa adicionada",
        updated: "Tarefa atualizada",
        deleted: "Tarefa excluída",
        completed: "Tarefa concluída",
        next_scheduled: "Feito! A próxima ficou para %{date}",
        empty: "Nada a fazer. Adicione uma tarefa no botão +.",
        repeats: "Repete",
        groups: {
          overdue: "Atrasadas",
          today: "Hoje",
          upcoming: "Próximas",
        },
        fields: {
          title: "Título da tarefa",
          description: "Descrição",
          due_date: "Finalizar até",
          reminder: "Lembrar-me",
          remind_at: "Data e hora do lembrete",
          recurrence: "Repetir",
          recurrence_interval: "A cada quantos dias?",
        },
        reminders: {
          none: "Não lembrar",
          day_start: "No dia, às 9h",
          end_of_day_1h: "1 hora antes de acabar o dia (23h)",
          end_of_day_3h: "3 horas antes de acabar o dia (21h)",
          day_before: "1 dia antes (9h)",
          week_before: "1 semana antes (9h)",
          custom: "Personalizado…",
        },
        reminder_hint: "Lembrete em %{date}",
        reminder_in_past: "O horário deste lembrete já passou",
        recurrences: {
          none: "Não repete",
          daily: "Diariamente",
          weekdays: "Dias úteis (seg–sex)",
          weekly: "Semanalmente",
          monthly: "Mensalmente",
          yearly: "Anualmente",
          custom: "Personalizado…",
        },
        recurrence_hints: {
          daily: "Repete todos os dias",
          weekdays: "Repete de segunda a sexta",
          weekly: "Repete toda %{weekday}",
          monthly: "Repete todo dia %{day}",
          yearly: "Repete todo ano em %{date}",
          custom:
            "Repete a cada %{smart_count} dia |||| Repete a cada %{smart_count} dias",
        },
      },
      reminders: {
        enable: "Ativar notificações",
        enabled: "Notificações ativadas",
        denied:
          "As notificações estão bloqueadas. Permita nas configurações do site no seu navegador para receber os lembretes.",
        unsupported: "Seu navegador não suporta notificações.",
        hint: "Os lembretes aparecem enquanto o CRM estiver aberto em uma aba do navegador.",
        notification_title: "Lembrete: %{title}",
        due: "Prazo: %{date}",
      },
      life_wheel: {
        title: "Roda da Vida",
        subtitle: "Metodologia PRO",
        fill: "Preencher minha avaliação",
        edit: "Editar avaliação",
        empty:
          "Avalie 12 áreas da sua vida para ver onde você está hoje e aonde quer chegar em 1 ano.",
        updated_at: "Atualizada em %{date}",
        area: "Área",
        current: "Atual",
        target: "Em 1 ano",
        dialog_description:
          "Dê uma nota de 0 a 10 para cada área: como você se vê hoje e aonde quer chegar em 1 ano. Passe o mouse sobre uma área para saber mais.",
        zero_warning:
          "Uma área com 0 no atual e 0 em 1 ano não entrará no gráfico.",
        min_topics: "Preencha pelo menos 3 áreas para ver o gráfico.",
        saved: "Avaliação salva",
        invalid_score: "Digite um número de 0 a 10",
        topics: {
          emotional: {
            name: "Emocional",
            description:
              "Como você lida com seus sentimentos, o estresse e a autoestima.",
          },
          spiritual: {
            name: "Espiritual",
            description:
              "Sua conexão com a fé, o propósito e os valores que dão sentido à sua vida.",
          },
          intellectual: {
            name: "Intelectual",
            description:
              "Aprendizado contínuo, leitura e desenvolvimento do seu raciocínio.",
          },
          serving: {
            name: "Servir",
            description:
              "O quanto você contribui com os outros e com a comunidade: voluntariado, ajuda, retribuição.",
          },
          relatives: {
            name: "Parentes",
            description:
              "Sua relação com a família estendida: pais, irmãos, tios, primos.",
          },
          family: {
            name: "Família",
            description:
              "Seu núcleo familiar: o tempo e o cuidado com seus filhos e com quem mora com você.",
          },
          marital: {
            name: "Conjugal",
            description:
              "A qualidade do seu relacionamento com seu cônjuge ou parceiro(a).",
          },
          health: {
            name: "Saúde",
            description:
              "Seu corpo e sua energia: sono, alimentação, exercícios e cuidados médicos.",
          },
          professional: {
            name: "Profissional",
            description: "Satisfação e evolução no trabalho e na carreira.",
          },
          academic: {
            name: "Acadêmico",
            description:
              "Sua formação: cursos, graduação, pós e certificações.",
          },
          financial: {
            name: "Financeiro",
            description:
              "O controle do seu dinheiro: renda, gastos, reservas e investimentos.",
          },
          social: {
            name: "Social",
            description: "Amizades, networking e sua vida social.",
          },
        },
      },
    },
  },
} satisfies CrmMessages;
